import {
  SOURCING_EVENT_LIST_LOAD,
  SOURCING_EVENT_LIST_ERROR,
  SOURCING_EVENT_LIST_SEARCH,
  SOURCING_EVENT_LIST_ALL_STATUS,
  SOURCING_EVENT_LIST_ALL_SEAL_STATUS,
  SOURCING_EVENT_LIST_ALL_AWARD,
  SOURCING_EVENT_LIST_ALL_USER,
  SOURCING_EVENT_LIST_SUCCEED,
  SOURCING_EVENT_LIST_EVENTS,
} from '../constants'

export const searchEventListSearch = (search = '', enterSearch = null) => {
  return { type: SOURCING_EVENT_LIST_SEARCH, search, enterSearch }
}

export const searchEventListAllEventType = (
  eventTypeID = 0,
  selectedAllEventType = null
) => ({
  type: SOURCING_EVENT_LIST_EVENTS,
  eventTypeID,
  selectedAllEventType,
})

export const searchEventListAllStatus = (
  status = 0,
  selectedAllStatus = null
) => ({
  type: SOURCING_EVENT_LIST_ALL_STATUS,
  status,
  selectedAllStatus,
})

export const searchEventListSealStatus = (
  sealStatus = 0,
  selectedSealStatus = null
) => ({
  type: SOURCING_EVENT_LIST_ALL_SEAL_STATUS,
  sealStatus,
  selectedSealStatus,
})

export const searchEventListAllAward = (
  allAward = 0,
  selectedAwardStatus = null
) => ({
  type: SOURCING_EVENT_LIST_ALL_AWARD,
  allAward,
  selectedAwardStatus,
})

export const searchEventListAllUser = (
  allUser = 0,
  selectedAllUser = null
) => ({
  type: SOURCING_EVENT_LIST_ALL_USER,
  allUser,
  selectedAllUser,
})
